import { render, staticRenderFns } from "./Reader.view.vue?vue&type=template&id=5bd38977&scoped=true&"
import script from "./Reader.view.vue?vue&type=script&lang=ts&"
export * from "./Reader.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd38977",
  null
  
)

export default component.exports